import secureStorage from "./locStore";

export const setSession = (token, expiryInMinutes = 60) => {
  const now = new Date();
  const expiryTime = new Date(now.getTime() + expiryInMinutes * 60000);

  secureStorage.setItem("token", token);
  secureStorage.setItem("expiry", expiryTime.toISOString());
};

export const isSessionValid = () => {
  const expiry = secureStorage.getItem("expiry");
  if (!expiry) return false;

  return new Date() < new Date(expiry);
};

export const logoutUser = () => {
  secureStorage.removeItem("userdata");
  secureStorage.removeItem("token");
  secureStorage.removeItem("expiry");
  window.location.href = "/";
};

export const getToken = () => {
  if (!isSessionValid()) {
    logoutUser();
    return null;
  }
  return secureStorage.getItem("token");
};
